import { ChangeDetectionStrategy, Component, HostListener, inject } from "@angular/core";
import { NewSnackbarService } from "src/app/services/snackbar-new.service";
import { DefaultComponent } from "./default.component";
import { SnackbarTemplateComponent } from "./snackbar-template.component";
@Component({
  selector: "app-snackbar",
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: "",
})
export class SnackbarComponent<T = unknown> extends DefaultComponent {
  public snackbar: NewSnackbarService;
  public data: T | null;
  public ref: SnackbarTemplateComponent | null;

  public constructor() {
    super();
    this.snackbar = inject(NewSnackbarService);
    this.data = null;
    this.ref = null;
  }

  @HostListener("click")
  public onHostClick(): void {
    this.close();
  }

  public close(): void {
    const ref = this.ref;
    if (ref) {
      ref.close();
    } else {
      throw new Error("Could not find snackbar template reference.");
    }
  }
}
